import shocksList from './List'
import shocksShow from './Show'
import shocksEdit from './Edit'

const shocksResource = {
  list: shocksList,
  show: shocksShow,
  edit: shocksEdit,
}

export default shocksResource
